// extracted by mini-css-extract-plugin
export var container = "_qa-0";
export var table = "_qa-2";
export var tableWrapper = "_qa-1";